import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useNotificationNavigation } from "../Contexts/NotificationProvider";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Index = ({ children }) => {
    const component = useSelector((state) => state.component);
    const navigate = useNavigate();
    useNotificationNavigation(navigate);
    return (
        <React.Fragment>
            <Header />
            <div className="layout">
                <Sidebar />
                <div className={`content-panel ${component?.sideBar ? "content-panel-lg" : "content-panel-sm"}`}>
                    {children}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Index;
